import React, { useEffect, useState } from "react";
import type { HedisPopUpConfig  } from "interfaces/MemberPortalConfig";
import { HedisPopUp } from "components/molecules/HedisPopUp/HedisPopUp";
import hedisPopUpService from "services/hedisPopUpService";
import { useLocation } from "react-router-dom";
import { lastMessageCategorySent$ } from "services/subjects";

const MESSAGE_CENTER_PATH = "/message-center";

export function HedisPopUps() {
    const [showPopUps, setShowPopUps] = useState(false);
    const [popUpConfigs, setPopUpsConfigs] = useState<HedisPopUpConfig[]>([]);
    const location  = useLocation();

    useEffect(() => {
        if(location.pathname.toLowerCase().includes(MESSAGE_CENTER_PATH)) {
            setShowPopUps(false);
        }
        else {
            setShowPopUps(true);
        }
    }, [location.pathname]);

    useEffect(() => {
        const hedisPopUpsSubscription = hedisPopUpService.get$().subscribe((response) => {
            setPopUpsConfigs(response.response);
        });

        return () => hedisPopUpsSubscription.unsubscribe();
    }, []);

    useEffect(() => {
        if(!popUpConfigs.length) {
            return;
        }
        const lastMessageCategorySentSubscription = lastMessageCategorySent$.subscribe({
            next: (messageCategory) => {
                setPopUpsConfigs((latestPopUpConfigs) => latestPopUpConfigs.filter(popUp => popUp.messageCenterCategory !== messageCategory));
            },
        });

        return () => {
            lastMessageCategorySentSubscription.unsubscribe();
        };
    }, [popUpConfigs, popUpConfigs]);

    if(!showPopUps) {
        return null;
    }

    return (popUpConfigs?.map(hedisPopUpConfig => (
        <HedisPopUp
            key={hedisPopUpConfig.campaignId}
            hedisPopUpConfig={hedisPopUpConfig}
        />
    )));
}
